import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class Network360WebClientService {
    constructor() {
        this.baseURL = 'network360WebClient';
    }

    getDeviceStatus(serviceNumber) {
        return fetch(SERVER_URL + this.baseURL + '/getDeviceStatus', {
            crossDomain: true,
            method: 'post',
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")},
            body: serviceNumber
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return result.json();
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

}
